const config = {
  STRIPE_KEY:
    "pk_test_51OcwNlHbJsmiUKTSBscrOMVHSjFXtjWzsxi8bubYL0et8hGsxWjvTe9HWXFR5wvd63FiiC5Q0DsY6su7QujZx7d00AvMR1xQu",
  GOOGLE_MAPS_API_KEY: "AIzaSyDT7zTNbhCpReHPwDlM_UQ7MTiMp63dbZI",
  PUSHER_APP_KEY: "57ff4bb1deb91e8f56f9",
  PUSHER_CLUSTER: "us2",
  PUSHER_SECRET: "dbe3a0380fbb9bc23565",
  PUSHER_APP_ID: "2052534",
  // Pusher auth endpoint for private channels
  PUSHER_AUTH_ENDPOINT:
    "https://xzkw-tynl-zqtb.n7c.xano.io/api:UIrow74p/messages/authenticate",
};

export default config;
